class ContextObject
	label: ->
	value: ->
	score: ->
class QuestionContext extends ContextObject
	constructor: (question, response) ->
		super()
		@question = question
		@response = response
		@variables = []
		for i,variable of @question.variables()
			if not variable.get('choice') and not variable.id.endsWith('_na')
				@variables.push new VariableContext(variable, @response)

	label: ->
		labels = []
		for variable in @variables
			if not EvaluationVisitor.prototype.is_empty(variable.value())
				labels.push variable.label()
			
		if not labels.length then '' else if labels.length==1 then labels[0] else labels

	value: ->
		values = []
		for variable in @variables
			if not EvaluationVisitor.prototype.is_empty(variable.value()) 
				values.push variable.value()
		if not values.length then '' else if values.length==1 then values[0] else values	

	score: ->
		scores = []
		for variable in @variables
			if not EvaluationVisitor.prototype.is_empty(variable.value()) 
				scores.push variable.score()
		if not scores.length then 0 else if scores.length==1 then scores[0] else scores	

	slice: (start, end)->
		new ListContext(@variables[start..end-1])

class ThreeDMatrixContext extends QuestionContext
	constructor: (question, response) ->
		super(question, response)
		@row_array = []
		rows = question.rows || question.attributes.rows
		columns = question.columns || question.attributes.columns
		for row, i in rows
			@row_array.push @variables[i*columns.length..(i+1)*columns.length-1]
		@col_array = []
		for col in columns
			@col_array.push []
		for variable, i in @variables
			@col_array[i%columns.length].push variable

	row: (index) ->
		new ListContext(@row_array[index])

	col: (index) ->
		new ListContext(@col_array[index])

class VariableContext extends ContextObject
	constructor: (@variable, @response) ->
		super()
		@has_other = false
		@choices = @variable.choices?() ? []

	label: -> 
		value = @value()
		if @choices.length
			label = []
			for choice in @choices
				if _.include((if value instanceof Array then value ? [] else [parseInt(value)]), choice.id)
					if not choice.get('other')
						label.push(choice.label())
					else
						other = $.extend({},choice.get('other'))
						other_text = (new VariableContext(other, @response)).value()
						label.push(other_text or choice.label())
					
			return label
		return @variable.getPipedValue(value)

	value: ->  if @response[@variable.id+'_0'] then @response[@variable.id+'_0'] else @response[@variable.id]

	score: ->  @variable.getScore(@value())


class ListContext extends ContextObject
	constructor: (object_list)->
		super()
		@variables = object_list

	label: ->
		labels = []
		for variable in @variables
			if not EvaluationVisitor.prototype.is_empty(variable.value())
				labels.push variable.label()
			
		if not labels.length then '' else if labels.length==1 then labels[0] else labels

	value: ->
		values = []
		for variable in @variables
			if not EvaluationVisitor.prototype.is_empty(variable.value()) 
				values.push variable.value()
		if not values.length then '' else if values.length==1 then values[0] else values	

	score: ->
		scores = []
		for variable in @variables
			if not EvaluationVisitor.prototype.is_empty(variable.value()) 
				scores.push variable.score()
		if not scores.length then 0 else if scores.length==1 then scores[0] else scores	

	slice: (start, end)->
		new ListContext(@variables[start..end-1])


_.extend exports, {
	QuestionContext, VariableContext, ThreeDMatrixContext
}
